var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEauSolaire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 26.9167C14.63 26.9167 11.0833 23.37 11.0833 19C11.0833 14.63 14.63 11.0833 19 11.0833C23.37 11.0833 26.9167 14.63 26.9167 19C26.9167 23.37 23.37 26.9167 19 26.9167ZM19 14.25C16.3875 14.25 14.25 16.3875 14.25 19C14.25 21.6125 16.3875 23.75 19 23.75C21.6125 23.75 23.75 21.6125 23.75 19C23.75 16.3875 21.6125 14.25 19 14.25ZM20.5833 0H17.4167V7.91667H20.5833V0ZM20.5833 30.0833H17.4167V38H20.5833V30.0833ZM7.91667 17.4167H0V20.5833H7.91667V17.4167ZM38 17.4167H30.0833V20.5833H38V17.4167ZM33.5508 6.68167L31.3183 4.44917L25.7133 10.0542L27.9458 12.2867L33.5508 6.68167ZM12.2867 27.9617L10.0542 25.7292L4.44917 31.3342L6.68167 33.5667L12.2867 27.9617ZM12.2867 10.0542L6.68167 4.44917L4.44917 6.68167L10.0542 12.2867L12.2867 10.0542ZM33.5667 31.3342L27.9617 25.7292L25.7292 27.9617L31.3342 33.5667L33.5667 31.3342Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEauSolaire);
export default __webpack_public_path__ + "static/media/eau_solaire.053ad7e60ffd5a5880d4b4ce4c747e78.svg";
export { ForwardRef as ReactComponent };